var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumber6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 121,
    viewBox: "0 0 65 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.6596 88.5676C64.6596 106.228 49.9329 120.84 32.2723 120.84C14.6117 120.84 0 106.228 0 88.5676C0 83.9079 1.51487 79.5551 2.70375 75.5666C3.89262 71.5781 7.24835 56.9089 26.5197 0.839844H33.2694C25.9061 22.3164 16.3375 51.6356 13.0202 62.2013C15.3596 59.9961 23.5666 56.3144 32.2915 56.3144C49.9521 56.3144 64.6788 70.9261 64.6788 88.5867L64.6596 88.5676ZM58.1592 88.5676C58.1592 74.0901 46.7498 62.7958 32.2723 62.7958C17.7949 62.7958 6.50051 74.0901 6.50051 88.5676C6.50051 103.045 17.9099 114.339 32.2723 114.339C46.6347 114.339 58.1592 102.93 58.1592 88.5676Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber6);
export default __webpack_public_path__ + "static/media/NUMBER_6.e139c2f094942854429250eea288eeab.svg";
export { ForwardRef as ReactComponent };